/* eslint-disable */
import React from 'react';
import { Input, Radio, Button, Popconfirm } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { ContentItem, DictionaryContent } from '../styles';

function DictionaryBlock({
    dict,
    searchText,
    setSearchText,
    isExpanded,
    toggleExpanded,
    selectedItems,
    handleAddItem,
    handleChangeItemDataType,
    onDetach,
}) {
    if (!dict) {
        return <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>Справочник не найден или был удалён</div>;
    }

    const content = dict.content || {};
    const entries = Object.entries(content);

    const filteredEntries = entries.filter(([key, value]) => {
        const searchLower = searchText.toLowerCase();
        const keyMatch = key.toLowerCase().includes(searchLower);
        const valueStr = typeof value === 'object' ? JSON.stringify(value) : String(value);
        const valueMatch = valueStr.toLowerCase().includes(searchLower);
        return keyMatch || valueMatch;
    });

    const selectedFromThis = selectedItems.find(
        (item) => item.dictionaryId === dict.id,
    );

    return (
        <div style={{ marginTop: 16 }}>
            {selectedFromThis && (
                <div
                    style={{
                        marginBottom: 12,
                        padding: 12,
                        background: '#e6f7ff',
                        border: '1px solid #91d5ff',
                        borderRadius: 4,
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <div style={{ fontWeight: 'bold', color: '#1890ff' }}>
                            Выбранное значение:
                        </div>
                        {onDetach && (
                            <Popconfirm
                                title={`Открепить значение из "${dict.name}"?`}
                                description="Привязка к этому справочнику будет удалена."
                                onConfirm={onDetach}
                                okText="Да, открепить"
                                cancelText="Отмена"
                            >
                                <Button danger size="small">
                                    Открепить
                                </Button>
                            </Popconfirm>
                        )}
                    </div>
                    <div style={{ marginBottom: 4 }}>
                        <strong>{selectedFromThis.integrationKey || selectedFromThis.key}:</strong>
                        {' '}
                        {selectedFromThis.dataType === 'key'
                            ? selectedFromThis.key
                            : (typeof selectedFromThis.value === 'object'
                                ? JSON.stringify(selectedFromThis.value)
                                : String(selectedFromThis.value)
                            )
                        }
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                        Сохранить:
                        <Radio.Group
                            size="small"
                            value={selectedFromThis.dataType}
                            onChange={(e) => {
                                e.stopPropagation();
                                const index = selectedItems.findIndex(
                                    item => item.dictionaryId === dict.id,
                                );
                                if (index !== -1) {
                                    handleChangeItemDataType(index, e.target.value);
                                }
                            }}
                            style={{ marginLeft: 8 }}
                        >
                            <Radio.Button value="key">Ключ</Radio.Button>
                            <Radio.Button value="value">Значение</Radio.Button>
                        </Radio.Group>
                    </div>
                </div>
            )}

            <div style={{ padding: 16, background: '#f5f5f5', borderRadius: 4 }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: isExpanded ? 12 : 0,
                        cursor: 'pointer',
                    }}
                    onClick={toggleExpanded}
                >
                    <h4 style={{ margin: 0 }}>
                        {isExpanded ? '▼' : '▶'}
                        {' '}
                        {dict.name}
                        {dict.external_integration_key && (
                            <span style={{ fontSize: '12px', color: '#666', marginLeft: 8 }}>
                                (ключ:
                                {' '}
                                {dict.external_integration_key}
                                )
                            </span>
                        )}
                    </h4>
                </div>

                {isExpanded && (
                    <>
                        <div style={{ marginBottom: 12, marginTop: 12 }}>
                            <Input
                                placeholder="Поиск по ключу или значению..."
                                prefix={<SearchOutlined />}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                allowClear
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>

                        <DictionaryContent style={{ maxHeight: 300 }}>
                            {filteredEntries.length === 0 ? (
                                <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
                                    Ничего не найдено
                                </div>
                            ) : (
                                filteredEntries.map(([key, value]) => {
                                    const isSelected = selectedItems.some(
                                        (item) => item.dictionaryId === dict.id && item.key === key,
                                    );

                                    return (
                                        <ContentItem
                                            key={key}
                                            selected={isSelected}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAddItem(dict, key, 'value');
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div>
                                                <strong>Ключ:</strong>
                                                {' '}
                                                {key}
                                            </div>
                                            <div>
                                                <strong>Значение:</strong>
                                                {' '}
                                                {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                            </div>
                                            {isSelected && (
                                                <div style={{ marginTop: 4, color: '#52c41a', fontSize: '12px' }}>
                                                    ✓ Выбрано
                                                </div>
                                            )}
                                        </ContentItem>
                                    );
                                })
                            )}
                        </DictionaryContent>
                    </>
                )}
            </div>
        </div>
    );
}

export default DictionaryBlock;
